import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
    state:{
        userMsg:JSON.parse(sessionStorage.getItem('userMsg')) || {},

    },
    getters:{
        getUserMsg: state=>{
            return state.userMsg
        },
        
    },
    mutations:{
        updateUserMsg(state,userMsg){
            state.userMsg = userMsg
        },
        
    },
    actions: {

    }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js